<mat-checkbox   #checkbox
                class   =   "select-all mat-option" 
                (click) =   "$event.stopPropagation();"
                (change)=   "toggleSelection($event)">
                <span translate>
                    <b>{{text | uppercase}}</b>
                </span>
</mat-checkbox>

<!--
[indeterminate]="isIndeterminate()"
[checked]="isChecked()" 
-->